import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "surface-ground" }
const _hoisted_2 = { class: "grid" }
const _hoisted_3 = { class: "flex border-bottom-1 surface-border pb-4" }
const _hoisted_4 = {
  class: "mr-3",
  style: {"width":"70px","height":"70px"}
}
const _hoisted_5 = { class: "flex flex-column align-items-start" }
const _hoisted_6 = { class: "flex justify-content-between pt-4" }
const _hoisted_7 = {
  key: 0,
  class: "p-5 flex flex-column flex-auto justify-content-center align-items-start"
}
const _hoisted_8 = {
  key: 1,
  class: "p-5 flex flex-column flex-auto justify-content-center align-items-start"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl text-900 font-medium mb-1 p-2" }, " You have no campaigns. Create one now! ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaigns, (campaign, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "col-12 md:col-6 xl:col-4 p-3"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["surface-card shadow-2 border-round p-4", { 'opacity-60': !_ctx.isCampaignActive(campaign) }])
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_Button, {
                    icon: "pi pi-megaphone",
                    rounded: "",
                    severity: _ctx.isCampaignActive(campaign) ? undefined : 'secondary'
                  }, null, 8, ["severity"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["text-xl font-medium mb-1", _ctx.isCampaignActive(campaign) ? 'text-900' : 'text-500'])
                  }, _toDisplayString(campaign.name), 3),
                  _createElementVNode("span", {
                    class: _normalizeClass(["font-medium mb-2", _ctx.isCampaignActive(campaign) ? 'text-600' : 'text-400'])
                  }, _toDisplayString(campaign.description), 3),
                  _createElementVNode("span", {
                    class: _normalizeClass(["border-round inline-flex py-1 px-2 text-sm", _ctx.isCampaignActive(campaign) ? 'bg-blue-50 text-blue-400' : 'surface-200 text-500'])
                  }, _toDisplayString(campaign.status), 3)
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_Button, {
                  onClick: ($event: any) => (_ctx.confirmDeleteCampaign(campaign.campaignId)),
                  label: "Delete",
                  icon: "pi pi-trash",
                  class: "p-button-outlined p-button-secondary w-6 mr-2"
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  onClick: ($event: any) => (_ctx.goToCampaign(campaign.campaignId)),
                  label: "View",
                  icon: "pi pi-search",
                  class: "p-button-outlined p-button-secondary w-6 ml-2"
                }, null, 8, ["onClick"])
              ])
            ], 2)
          ]))
        }), 128)),
        (_ctx.campaigns && _ctx.campaigns.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_Button, {
                onClick: _ctx.goToCreateCampaign,
                icon: "pi pi-plus",
                rounded: ""
              }, null, 8, ["onClick"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_Button, {
                onClick: _ctx.goToCreateCampaign,
                icon: "pi pi-plus",
                rounded: ""
              }, null, 8, ["onClick"])
            ]))
      ])
    ]),
    _createVNode(_component_ConfirmDialog)
  ], 64))
}